import { createUniqueId, useContext } from "solid-js";
import ToggleButton from "~/components/shared/Display/ToggleButton";
import SiteAssetsContext from "~/components/shared/SiteAssets/SiteAssetsContext";

function ToggleFeature() {
  const context = useContext(SiteAssetsContext);
  if (!context) {
    throw new Error(
      "SiteAssetsContext is undefined. This usually means you are trying to use context outside of the provider. Make sure your component is wrapped with the SiteAssetsContext.Provider.",
    );
  }
  const { cssHandler, siteAssetsState, webfontHandler } = context;
  const [id1, id2] = [createUniqueId(), createUniqueId()];
  return (
    <>
      <ToggleButton
        id={id1}
        classId="toggle-css"
        label="CSS"
        onToggle={() => cssHandler()}
        isActive={siteAssetsState().css}
      />
      <ToggleButton
        id={id2}
        label="Web fonts"
        onToggle={() => webfontHandler()}
        isActive={siteAssetsState().webFonts}
      />
    </>
  );
}

export default ToggleFeature;
